import { render, staticRenderFns } from "./ClientLiableList.vue?vue&type=template&id=2550cdc1&"
import script from "./ClientLiableList.vue?vue&type=script&lang=js&"
export * from "./ClientLiableList.vue?vue&type=script&lang=js&"
import style0 from "./ClientLiableList.vue?vue&type=style&index=0&id=2550cdc1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports